module.exports = __webpack_public_path__ + "media/images/imgfondo-99861fac3d9df0cb72a23e1af6e35ab1.jpg";